import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Icons } from '@/theme/Images'
import { Button } from '@/components/index'
import { ExtendedTooltip } from '@/components'
import { Skeleton } from '@/components/ui/skeleton'
import { ROUTE_PAYMENTS, ROUTE_PAYMENTS_MAKE_PAYMENT } from '../../routes/paths'

const AccountSummarySkeleton = () => {
  const [showBalances, setShowBalances] = useState(false)

  return (
    <div data-testid="right-column">
      <div className="top-content w-full border-b-dGray-200 border-b-[1px] px-5 py-8">
        <div className="w-full flex flex-col md:flex-row md:flex-wrap justify-between items-start">
          <div className="w-full md:w-auto flex flex-row md:flex-col justify-between md:justify-start items-center">
            <div className="flex flex-col justify-start items-start">
              <div className="w-full flex flex-row justify-start items-center">
                <p className="font-semibold text-lg leading-5 text-dGray-900"> Statement Balance</p>
                <ExtendedTooltip
                  trigger={<img src={Icons.helpIcon} className="cursor-pointer ml-2" width={13.5} />}
                  title={' Statement Balance'}
                  content="The total balance on your account at the end of your last billing cycle. This amount does not reflect any payments made or applied to your balance after the statement was generated."
                />
              </div>
              <Skeleton className="w-40 h-10 mt-3" data-testid="balance-field-sk" />
              <Skeleton className="w-40 h-6 mt-3" data-testid="balance-field-sk" />
            </div>
            <div
              className="flex md:hidden flex-row justify-end items-center cursor-pointer"
              onClick={() => setShowBalances(prev => !prev)}
            >
              <p className="text-md font-semibold">{`Show ${showBalances ? 'less' : 'more'}`}</p>
              <img
                src={showBalances ? Icons.roundedGrayMinusIcon : Icons.roundedGrayPlusIcon}
                alt="icon"
                className="ml-2"
              />
            </div>
          </div>
          <div className={`${showBalances ? 'flex mt-4' : 'hidden'}  md:flex flex-col justify-start`}>
            <div className="flex flex-row justify-start items-center">
              <p className="font-inter font-semibold text-lg leading-7 text-dGray-900 tracking-normal">
                Current Balance
              </p>
              <ExtendedTooltip
                trigger={<img src={Icons.helpIcon} className="cursor-pointer ml-2" width={13.5} />}
                title={'Current Balance'}
                content="The total balance on your account, including all posted purchases, fees, and interest, minus any payments or credits. This amount updates as new purchases and payments are posted and may differ from your Statement Balance, which reflects the amount due for your last billing cycle."
              />
            </div>
            <Skeleton className="w-28 h-7 mt-3" data-testid="balance-field-sk" />
            <Skeleton className="w-40 h-6 mt-3" data-testid="balance-field-sk" />
          </div>
          <div className={`${showBalances ? 'flex mt-4' : 'hidden'}  md:flex flex-col justify-start`}>
            <div className="flex flex-row justify-start items-center">
              <p className="font-inter font-semibold text-lg leading-7 text-dGray-900 tracking-normal">
                Minimum Payment
              </p>
              <ExtendedTooltip
                trigger={<img src={Icons.helpIcon} className="cursor-pointer ml-2" width={13.5} />}
                title={'Minimum Payment'}
                content="The minimum amount you must pay by the due date to avoid late fees and maintain your account in good standing. Paying only the minimum may result in interest charges on the remaining balance."
              />
            </div>
            <Skeleton className="w-28 h-7 mt-3" data-testid="balance-field-sk" />
            <Skeleton className="w-40 h-6 mt-3" data-testid="balance-field-sk" />
          </div>
          <div className="w-full md:w-auto flex flex-col justify-start">
            <Link to={`/${ROUTE_PAYMENTS}${ROUTE_PAYMENTS_MAKE_PAYMENT}`} className="w-full mt-8 md:mt-0">
              <Button className="w-full bg-brand-600 hover:bg-brand-700 text-sm text-white">Make Payment</Button>
            </Link>
            <Skeleton className="w-36 h-4 mt-3 md:ml-5" />
            <div className="w-full flex flex-row justify-start md:justify-end items-center mt-2">
              <Skeleton className="w-44 h-4 mt-2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountSummarySkeleton
